import { useEffect, useState } from "react";
import { Button, Card, Col, Label, Row } from "reactstrap";
import { IoAddCircle } from "react-icons/io5";
import { CrossIcon } from "../../assets/designedPickedIcons";
import { RxCross2 } from "react-icons/rx";

const ImagesUploadInput = ({ label, value, setValue, maxImages }) => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (Array.isArray(value)) {
      console.log("creating boxes");
      let totalPresentImages = value?.length;
      let remainingAllowed = maxImages - totalPresentImages;
      if (remainingAllowed <= 0) {
        {
          console.warn("No more images allowed");
          setItems(value);
        }
      } else {
        let array = [
          ...value,
          ...Array?.from({ length: remainingAllowed }, (_) => null),
        ];
        setItems(array);
      }
    }
  }, [value]);

  const handlePhotoUpload = (value, at) => {
    let array = [...items];
    array[at] = value;
    let imagesData = array.filter((item) => item !== null);

    setItems(imagesData);
    setValue(imagesData);
  };
  const handleRemovePhoto = (at) => {
    let array = [...items];
    array[at] = null;
    setItems(array);
  };

  return (
    <div>
      {label && (
        <Label className="figma-input-label" style={{ marginBottom: "0.9rem" }}>
          {label}
        </Label>
      )}
      <Row
        style={{ borderRadius: "13.48px" }}
        className="gy-md-0 gx-3 gy-3 gy-md-3 bg-transparent "
      >
        {items?.map((item, index) => (
          <Col md={4}>
            <>
              <Label
                htmlFor={`img-${index}`}
                className="m-0 p-0 d-flex full-width"
              >
                <Card
                  style={{
                    background: "rgba(241, 241, 241, 1)",
                    minHeight: "150px",
                    borderRadius: "18.19px",
                  }}
                  className="border-dashed-primary-blue p-0  position-relative d-flex align-items-center justify-content-center full-width"
                >
                  {item !== null && (
                    <Button
                      onClick={(e) => {
                        e?.preventDefault();
                        handleRemovePhoto(index);
                      }}
                      className="bg-danger p-0 full-rounded  position-absolute border-none d-flex align-items-center justify-content-center"
                      style={{
                        height: 30,
                        width: 30,
                        top: "-15px",
                        right: "-14px",
                        zIndex: 3,
                      }}
                    >
                      <RxCross2 size={15} color="white" strokeWidth={"1px"} />
                    </Button>
                  )}

                  {item !== null ? (
                    <img
                      height={150}
                      src={
                        typeof item === "object"
                          ? URL.createObjectURL(item)
                          : item
                      }
                      style={{ borderRadius: "18.19px" }}
                      className="full-width object-fit-cover"
                      typeof="image"
                    />
                  ) : (
                    <div className="color-primary-blue">
                      <IoAddCircle size={30} />
                    </div>
                  )}
                </Card>
              </Label>
              <input
                onChange={(e) => handlePhotoUpload(e?.target?.files[0], index)}
                className="d-none"
                type="file"
                id={`img-${index}`}
                accept="image/*"
              />
            </>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default ImagesUploadInput;
